import * as React from 'react';
import { Button } from 'design-system';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import HowToBuyModal from './HowToBuyModal';
import useHandleBuyAssetForTradingAccount from '../hooks/useHandleBuyAssetForTradingAccount';
import { selectAutoInvestPlanForAccount, selectTradingAccountFromId } from '../reducers/selectors';
import { useConnectedAccount } from '../hooks/selectors';
import { blockInvestActionOnWeb } from '../webGate';
const DepositAndBuyAssetBuyButton = ({ amount, assetId, depositMethod, tradingAccountId, }) => {
    const navigation = useMainStackNavigation();
    const connectedAccount = useConnectedAccount();
    const tradingAccount = useAppSelector((state) => selectTradingAccountFromId(state, tradingAccountId));
    const autoinvestPlanForAccount = useAppSelector((state) => selectAutoInvestPlanForAccount(state, tradingAccountId));
    const isAssetInAutoInvestForAccount = autoinvestPlanForAccount
        ? autoinvestPlanForAccount.allocations.some((allocation) => allocation.assetId === assetId)
        : undefined;
    const handleDepositAndBuy = useHandleBuyAssetForTradingAccount();
    const navigateToOrderPreview = React.useCallback(() => {
        if (tradingAccount && amount && depositMethod) {
            navigation.navigate('SecclOrderPreviewScreen', {
                assetId,
                depositMethod,
                tradingAccountId,
                onConfirm: () => handleDepositAndBuy({ assetId, tradingAccountId, amount, depositMethod }),
                orderType: { type: 'buy', amount: { value: amount, currency: 'GBP' } },
                accountType: tradingAccount.accountType,
            });
        }
    }, [tradingAccount, amount, depositMethod, assetId, tradingAccountId, handleDepositAndBuy, navigation]);
    const onPress = React.useCallback(() => {
        if (tradingAccount) {
            if (amount && depositMethod) {
                // Paying by bank deposit is mobile-only; choosing how to buy below isn't
                if (blockInvestActionOnWeb('Buy'))
                    return;
                if (depositMethod === 'singleDirectDebit' &&
                    (connectedAccount?.investMandateStatus === 'INACTIVE' || connectedAccount?.investMandateStatus === 'NONE')) {
                    navigation.navigate('AutoinvestSelectFundingAccount', {
                        onDirectDebitSetup: navigateToOrderPreview,
                    });
                    return;
                }
                navigateToOrderPreview();
            }
            else {
                const navigateToBuyAsset = () => navigation.navigate('BuyAssetForTradingAccount', { assetId, tradingAccountId: tradingAccount.id });
                if (!isAssetInAutoInvestForAccount || autoinvestPlanForAccount?.status === 'paused') {
                    /**
                     * NOTE: should only be used in case where trading account id is set
                     */
                    HowToBuyModal.show(assetId, navigateToBuyAsset);
                }
                else {
                    navigateToBuyAsset();
                }
            }
        }
    }, [
        tradingAccount,
        amount,
        depositMethod,
        connectedAccount?.investMandateStatus,
        navigateToOrderPreview,
        isAssetInAutoInvestForAccount,
        autoinvestPlanForAccount?.status,
        assetId,
    ]);
    return <Button brand floating title="Buy" onPress={onPress}/>;
};
export default DepositAndBuyAssetBuyButton;
